<div style="background: #0a213c; padding: 5px; text-align:center; color:#fff;" mat-dialog-title>Error</div>
<div mat-dialog-content>
  <p style="padding: 20px;">{{ data.message }}</p>
</div>
<div mat-dialog-actions>
  <button class="btn create-ac-btn btn-lg btn-block" (click)="onNoClick()" style="width: 100%;">Ok</button>
  
</div>
